import styled from "styled-components";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import { PositionResult } from "common/position/dto/PositionResult";
import { NavLink } from "react-router-dom";
import { useUnosPositionDelete } from "hooks/unos/position/useUnosPositionDelete";
import { QUERY_KEYS } from "constant/react_query";
import { positionLinkSingle } from "common/position/position_link_common";
import useConfirm from "common/modal/ConfirmDialog";

type PositionSingleNavProps = {
  position: PositionResult;
  hideEditNav?: boolean;
  hideReadNav?: boolean;
};

const PositionSingleNav = ({
  position,
  hideEditNav,
  hideReadNav,
}: PositionSingleNavProps) => {
  const { positionDeleteMutate } = useUnosPositionDelete({
    invalidateKeys: [QUERY_KEYS.UNOS_POSITION_SEARCH],
  });

  const actionConfirm = useConfirm();

  const deleteHandle = async () => {
    const check = await actionConfirm({
      title: "Position",
      message: "Are you sure you want to delete position",
    });
    if (check) {
      positionDeleteMutate(position.id);
    }
  };

  return (
    <DivNav>
      <DeleteIcon onClick={deleteHandle} />
      {!hideEditNav && (
        <NavLink to={positionLinkSingle(position.id, true)}>
          <EditIcon />
        </NavLink>
      )}
      {!hideReadNav && (
        <NavLink to={positionLinkSingle(position.id)}>
          <ReadMoreIcon />
        </NavLink>
      )}
    </DivNav>
  );
};

const DivNav = styled.div`
  margin-top: 0.75rem;
  svg {
    margin-left: 1rem;
    cursor: pointer;
  }
  svg:hover {
    opacity: 0.8;
  }
  &&& > svg:first-of-type {
    margin-left: 0;
  }
`;

export default PositionSingleNav;
